import React from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import { green, grey, orange } from "@material-ui/core/colors";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

const useStyles = makeStyles((theme) => ({
  on: {
    color: green[600],
    fontSize: "20px",
  },
  idle: {
    color: orange[700],
    fontSize: "20px",
  },
  off: {
    color: grey[600],
    fontSize: "20px",
  },
}));

const UserStatusIcon = ({ user }) => {
  const classes = useStyles();
  if (!user || typeof user.online === "undefined") {
    return (
      <Tooltip title="Desconhecido">
        <ErrorIcon className={classes.off} />
      </Tooltip>
    );
  }

  if (user.online && user.isIdle) {
    return (
      <Tooltip title="Ocioso / Ausente">
        <AccessTimeIcon className={classes.idle} />
      </Tooltip>
    );
  }

  return user.online ? (
    <Tooltip title="Online">
      <CheckCircleIcon className={classes.on} />
    </Tooltip>
  ) : (
    <Tooltip title="Offline">
      <ErrorIcon className={classes.off} />
    </Tooltip>
  );
};

export default UserStatusIcon;
